import React from 'react';
import FilesErrorsItem from './FilesErrorsItem';
import getMimeTypeDescription from '../../helpers/getMimeTypeDescription';

export interface FilesErrorsProps {
  accept?: string;
  hasMimeTypeError?: boolean;
  customError?: string;
}

function FilesErrors(props: FilesErrorsProps) {
  const { accept, hasMimeTypeError, customError } = props;

  const mimetypeError = Boolean(accept) && Boolean(hasMimeTypeError) ? getMimeTypeDescription(accept) : null;

  return (
    <>
      {mimetypeError && <FilesErrorsItem error={`File must be ${mimetypeError}.`} />}
      <FilesErrorsItem error={customError} />
    </>
  );
}

export default FilesErrors;
